import { PnPerson } from './pn-person.class';
import uuidv4 from 'uuid/v4';
export const generateUndeterminedPerson = () => {
    return new PnPerson({
        isUndetermined: true,
        uuid: uuidv4(),
        type: null,
        roomId: null,
        state: {
            doxyVersion: { platform: 'web', version: 1 },
            cameraStatus: 'success',
            quality: '',
            username: 'Undetermined',
            status: null,
            onlyChat: null,
            hasCamera: null,
            privateData: { ip: null, location: null },
        },
    });
};
